"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4670],{

/***/ 3243:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ Iframe; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97997);

function Iframe(props) {
    // console.log({props})
    var url = props.url;
    var height = props.height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("iframe", {
        src: url,
        height: height,
        width: "100%",
        frameBorder: "0",
        title: "Iframe Content"
    });
}


/***/ }),

/***/ 14670:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ content_components_serializers; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs + 1 modules
var jsx_runtime = __webpack_require__(97997);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@sanity/asset-utils/dist/asset-utils.esm.js
var asset_utils_esm = __webpack_require__(81548);
// EXTERNAL MODULE: ./lib/sanity.js
var sanity = __webpack_require__(98107);
;// CONCATENATED MODULE: ./components/layout/content-components/serializers/figure.js




var ImageComponent = function(param) {
    var image = param.image, imageBlur = param.imageBlur, imageAltText = param.imageAltText, adjustedHeight = param.adjustedHeight, adjustedWidth = param.adjustedWidth;
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
        src: image,
        alt: imageAltText || "",
        blurDataURL: imageBlur || "",
        placeholder: imageBlur ? "blur" : "empty",
        layout: "intrinsic",
        width: adjustedWidth,
        height: adjustedHeight,
        className: "object-cover object-center w-full"
    });
};
function Figure(props) {
    var ref;
    // console.log({props})
    var image = props === null || props === void 0 ? void 0 : props.asset;
    var alt = props.alt;
    // const { asset } = props;
    var aspectRatio = (0,asset_utils_esm/* getImageDimensions */.pz)(props === null || props === void 0 ? void 0 : (ref = props.image) === null || ref === void 0 ? void 0 : ref.asset).aspectRatio;
    // console.log({aspectRatio})
    // return null
    var adjustedWidth = (props === null || props === void 0 ? void 0 : props.width) || 788;
    var adjustedHeight = Math.round(adjustedWidth / aspectRatio);
    var imageScaled = function(val) {
        return val ? "".concat((0,sanity/* urlFor */.uH)(val).auto("format").width(adjustedWidth).height(adjustedHeight).url()) : null;
    };
    var imageBlur = function(val) {
        return val ? "".concat((0,sanity/* urlFor */.uH)(val).auto("format").width(10).url()) : null;
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("figure", {
        className: "text-center",
        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ImageComponent, {
            image: imageScaled(props === null || props === void 0 ? void 0 : props.image),
            imageBlur: imageBlur(props === null || props === void 0 ? void 0 : props.image),
            imageAltText: alt,
            adjustedWidth: adjustedWidth,
            adjustedHeight: adjustedHeight
        })
    });
}

// EXTERNAL MODULE: ./components/layout/content-components/serializers/iFrame.js
var iFrame = __webpack_require__(3243);
;// CONCATENATED MODULE: ./components/layout/content-components/serializers/table.js

function Table(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    if (!props || (props === null || props === void 0 ? void 0 : (ref = props.rows) === null || ref === void 0 ? void 0 : ref.length) < 1) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
        className: "not-prose",
        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
            className: "flex flex-col",
            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "overflow-x-auto",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                    className: "inline-block min-w-full py-2 align-middle",
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                        className: "overflow-hidden shadow ring-1 ring-slate-800 ring-opacity-5 mx-1",
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("table", {
                            className: "min-w-full divide-y divide-gray-300",
                            children: [
                                ((ref3 = (ref1 = props === null || props === void 0 ? void 0 : props.rows[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.cells) === null || ref2 === void 0 ? void 0 : ref2.filter(Boolean)) === null || ref3 === void 0 ? void 0 : ref3.length) > 0 && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("thead", {
                                    className: "bg-gray-50",
                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("tr", {
                                        children: (ref4 = props === null || props === void 0 ? void 0 : props.rows[0]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.cells) === null || ref5 === void 0 ? void 0 : ref5.map(function(val, i) {
                                            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("th", {
                                                scope: "col",
                                                className: i === 0 ? "py-3 pl-4 pr-3 text-left text-xs font-medium tracking-wide text-gray-500 sm:pl-6" : "px-3 py-3 text-left text-xs font-medium tracking-wide text-gray-500",
                                                children: val
                                            }, i);
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("tbody", {
                                    className: "divide-y divide-gray-200 bg-white",
                                    children: (props === null || props === void 0 ? void 0 : (ref6 = props.rows) === null || ref6 === void 0 ? void 0 : ref6.length) > 1 && (props === null || props === void 0 ? void 0 : (ref7 = props.rows) === null || ref7 === void 0 ? void 0 : ref7.slice(1).map(function(row, i) {
                                        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("tr", {
                                            className: i % 2 === 0 ? undefined : "bg-gray-50",
                                            children: row.cells.map(function(cell, i) {
                                                return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("td", {
                                                    className: i === 0 ? "whitespace-nowrap py-4 pl-4 pr-3 text-sm text-gray-700 sm:pl-6" : "whitespace-nowrap px-3 py-4 text-sm text-gray-700",
                                                    children: cell
                                                }, i);
                                            })
                                        }, i);
                                    }))
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
}

// EXTERNAL MODULE: ./components/layout/content-components/serializers/pdf.js
var pdf = __webpack_require__(50121);
// EXTERNAL MODULE: ./node_modules/get-video-id/dist/get-video-id.esm.js
var get_video_id_esm = __webpack_require__(34329);
// EXTERNAL MODULE: ./node_modules/react-lite-youtube-embed/dist/index.es.jsx
var index_es = __webpack_require__(40640);
// EXTERNAL MODULE: ./node_modules/react-lite-youtube-embed/dist/LiteYouTubeEmbed.css
var LiteYouTubeEmbed = __webpack_require__(73879);
;// CONCATENATED MODULE: ./components/layout/content-components/serializers/youtube.js




function Youtube(props) {
    if (!props || !props.url) {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
            children: "Missing YouTube URL"
        });
    }
    var id = (0,get_video_id_esm/* default */.Z)(props.url).id;
    if (!id) {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
            children: "Missing YouTube URL"
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
        className: "not-prose",
        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(index_es/* default */.Z, {
            id: id,
            adNetwork: false,
            noCookie: true,
            thumbnail: ""
        })
    });
}

;// CONCATENATED MODULE: ./components/layout/content-components/serializers/file-download.js
/* provided dependency */ var process = __webpack_require__(83454);

function FileDownload(props) {
    var linkText = props.children[0];
    var linkID = props.mark.file.asset._ref;
    var linkURL = linkID.split("-")[1];
    var linkExt = linkID.split("-")[2];
    linkURL = "https://cdn.sanity.io/files/".concat(process.env.SANITY_STUDIO_API_PROJECT_ID, "/").concat(process.env.SANITY_STUDIO_API_DATASET, "/").concat(linkURL, ".").concat(linkExt);
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("a", {
        href: linkURL,
        target: "_blank",
        rel: "noopener noreferrer",
        children: linkText
    });
}

;// CONCATENATED MODULE: ./components/layout/content-components/serializers/index.js
/* provided dependency */ var serializers_process = __webpack_require__(83454);

var ref, ref1;



var IS_PROD = (serializers_process === null || serializers_process === void 0 ? void 0 : (ref = serializers_process.env) === null || ref === void 0 ? void 0 : "false") === "false" && (serializers_process === null || serializers_process === void 0 ? void 0 : (ref1 = serializers_process.env) === null || ref1 === void 0 ? void 0 : "G-MF0S173L5Y") ? true : false;






var handleCallClick = function(url) {
    if (IS_PROD) {
        return gtag_report_conversion("".concat(url));
    } else {
        return;
    }
};
var linkFunction = function(href, children) {
    if (href.includes("tel")) {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("a", {
            onClick: function() {
                return handleCallClick(href);
            },
            href: href,
            target: "_blank",
            rel: "noopener noreferrer",
            title: "call",
            "aria-label": "call",
            children: children
        });
    }
    if (href.includes("https") || href.includes("http") || href.includes("mailto")) {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("a", {
            href: href,
            children: children
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((link_default()), {
        href: href,
        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("a", {
            children: children
        })
    });
};
// TODO: Might want to find a 'React' version to embed Vimeo videos
var DynamicComponentWithNoSSR = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4831).then(__webpack_require__.bind(__webpack_require__, 74831));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(74831)
            ];
        }
    },
    ssr: false
});
var serializers = {
    types: {
        mainImage: function mainImage(props) {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Figure, (0,_object_spread/* default */.Z)({}, props.node));
        },
        youtube: function youtube(props) {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Youtube, (0,_object_spread/* default */.Z)({}, props.node));
        },
        vimeo: function vimeo(props) {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(DynamicComponentWithNoSSR, (0,_object_spread/* default */.Z)({}, props.node));
        },
        pdfFile: function pdfFile(props) {
            return props.node && props.node.file && props.node.file.asset && props.node.file.asset._ref ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(pdf/* PDF */.g, (0,_object_spread/* default */.Z)({}, props.node)) : null;
        },
        iframe: function iframe(props) {
            return props.node && props.node.url ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(iFrame/* Iframe */.h, (0,_object_spread/* default */.Z)({}, props.node)) : null;
        },
        anchor: function anchor(props) {
            var ref, ref1;
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                id: props === null || props === void 0 ? void 0 : (ref = props.node) === null || ref === void 0 ? void 0 : (ref1 = ref.anchorID) === null || ref1 === void 0 ? void 0 : ref1.current
            });
        },
        table: function table(props) {
            var ref, ref1;
            return (props === null || props === void 0 ? void 0 : props.node) && (props === null || props === void 0 ? void 0 : (ref = props.node) === null || ref === void 0 ? void 0 : (ref1 = ref.rows) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Table, (0,_object_spread/* default */.Z)({}, props.node)) : "";
        },
        // instagramPost(props) {
        //   return (<>instagramPost</>)
        // },
        // slideshow(props) {
        //   return props && props.node && props.node.slides ? <Slideshow {...props.node} /> : ''
        // },
        // imageGallery(props) {
        //   return props && props.node && props.node.images ? <Gallery {...props.node} /> : ''
        // },
        block: function(param) {
            var node = param.node, children = param.children;
            switch(node.style){
                case "h1":
                    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h1", {
                        children: children
                    });
                case "h2":
                    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h2", {
                        children: children
                    });
                case "h3":
                    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h3", {
                        children: children
                    });
                case "h4":
                    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h4", {
                        children: children
                    });
                case "h5":
                    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h5", {
                        children: children
                    });
                case "h6":
                    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h6", {
                        children: children
                    });
                case "blockquote":
                    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("blockquote", {
                        children: children
                    });
                default:
                    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                        children: children
                    });
            }
        }
    },
    marks: {
        text: function(props) {
            return "test";
        },
        subTitle: function(param) {
            var children = param.children;
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                className: "subTitle",
                children: children
            });
        },
        fileDownload: function fileDownload(props) {
            var ref;
            // console.log({props})
            switch(props === null || props === void 0 ? void 0 : (ref = props.mark) === null || ref === void 0 ? void 0 : ref._type){
                case "fileDownload":
                    if (props.mark.file && props.mark.file.asset && props.mark.file.asset._ref) {
                        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(FileDownload, (0,_object_spread/* default */.Z)({}, props));
                    } else {
                        return null;
                    }
            }
        },
        // eslint-disable-next-line react/display-name
        link: function(param) {
            var mark = param.mark, children = param.children;
            var blank = mark.blank, href = mark.href;
            if (!href) {
                return null;
            }
            return blank === true ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(jsx_runtime/* Fragment */.HY, {
                children: href.includes("https") || href.includes("http") ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("a", {
                    href: href,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    children: children
                }) : /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("a", {
                    href: href,
                    children: children
                })
            }) : /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(jsx_runtime/* Fragment */.HY, {
                children: linkFunction(href, children)
            });
        }
    },
    list: function(props) {
        switch(props.type){
            case "number":
                {
                    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("ol", {
                        className: "prose md:prose-lg lg:prose-xl max-w-none",
                        children: props.children
                    });
                }
            case "bullet":
                {
                    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("ul", {
                        className: "prose md:prose-lg lg:prose-xl max-w-none",
                        children: props.children
                    });
                }
            default:
                {
                    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("ul", {
                        className: "prose md:prose-lg lg:prose-xl max-w-none",
                        children: props.children
                    });
                }
        }
    }
};
/* harmony default export */ var content_components_serializers = (serializers);


/***/ }),

/***/ 50121:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ PDF; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97997);

function PDF(props) {
    var ID = props._key;
    var height = props.height || 960;
    var alt = props.alt ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .Fragment */ .HY, {
        children: props.alt
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .Fragment */ .HY, {
        children: "Your browser can not view this PDF Embed, however you can click the link below to download."
    });
    var downloadText = props.downloadText && props.downloadText;
    var PDFpath = props.file.asset._ref;
    PDFpath = PDFpath.replace("file-", "");
    PDFpath = PDFpath.replace("-pdf", "");
    PDFpath = "https://cdn.sanity.io/files/".concat("xmc289e8", "/").concat("development", "/").concat(PDFpath, ".pdf");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("object", {
                data: PDFpath,
                type: "application/pdf",
                width: "100%",
                height: height,
                children: alt
            }),
            downloadText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("p", {
                className: "mt-4",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("a", {
                    href: PDFpath,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    className: "inline-flex items-baseline space-x-3 group",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            fill: "none",
                            viewBox: "0 0 24 24",
                            stroke: "currentColor",
                            className: "w-5 h-5 not-sr-only",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                strokeWidth: "2",
                                d: "M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                            })
                        }),
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("span", {
                            className: "group-hover:underline",
                            children: downloadText
                        })
                    ]
                })
            })
        ]
    });
}


/***/ }),

/***/ 92377:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ config; }
/* harmony export */ });
// lib/config.js
var config = {
    /**
   * Find your project ID and dataset in `sanity.json` in your studio project.
   * These are considered “public”, but you can use environment variables
   * if you want differ between local dev and production.
   *
   * https://nextjs.org/docs/basic-features/environment-variables
   **/ dataset: "development" || 0,
    projectId: "xmc289e8",
    documentLimit: 8000,
    apiVersion: "2021-10-23",
    /**
   * Set useCdn to `false` if your application require the freshest possible
   * data always (potentially slightly slower and a bit more expensive).
   * Authenticated request (like preview) will always bypass the CDN
   **/ useCdn: "production" === "production"
};


/***/ }),

/***/ 98107:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$r": function() { return /* binding */ usePreviewSubscription; },
/* harmony export */   "YI": function() { return /* binding */ PortableText; },
/* harmony export */   "uH": function() { return /* binding */ urlFor; }
/* harmony export */ });
/* unused harmony export useCurrentUser */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var next_sanity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81035);
/* harmony import */ var _sanity_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92377);
// lib/sanity.js




/**
 * Set up a helper function for generating Image URLs with only the asset reference data in your documents.
 * Read more: https://www.sanity.io/docs/image-url
 **/ var urlFor = function(source) {
    return (0,next_sanity__WEBPACK_IMPORTED_MODULE_1__/* .createImageUrlBuilder */ .WK)(_sanity_config__WEBPACK_IMPORTED_MODULE_0__/* .config */ .v).image(source);
};
// Set up the live preview subscription hook
var usePreviewSubscription = (0,next_sanity__WEBPACK_IMPORTED_MODULE_1__/* .createPreviewSubscriptionHook */ .KF)(_sanity_config__WEBPACK_IMPORTED_MODULE_0__/* .config */ .v);
// Set up Portable Text serialization
var PortableText = (0,next_sanity__WEBPACK_IMPORTED_MODULE_1__/* .createPortableTextComponent */ .Kz)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, _sanity_config__WEBPACK_IMPORTED_MODULE_0__/* .config */ .v), {
    // Serializers passed to @sanity/block-content-to-react
    // (https://github.com/sanity-io/block-content-to-react)
    serializers: {}
}));
// Helper function for using the current logged in user account
var useCurrentUser = (0,next_sanity__WEBPACK_IMPORTED_MODULE_1__/* .createCurrentUserHook */ .Iy)(_sanity_config__WEBPACK_IMPORTED_MODULE_0__/* .config */ .v) // import {
 //   groq,
 //   createClient,
 //   createImageUrlBuilder,
 //   createPreviewSubscriptionHook,
 // } from 'next-sanity'
 // const config = {
 //   dataset: process.env.NEXT_PUBLIC_SANITY_DATASET,
 //   projectId: process.env.NEXT_PUBLIC_SANITY_PROJECT_ID,
 //   apiVersion: '2021-10-23',
 //   useCdn: process.env.NODE_ENV === 'production',
 // }
 // export const imageBuilder = source => createImageUrlBuilder(config).image(source)
 // export const usePreviewSubscription = createPreviewSubscriptionHook(config)
 // export const client = createClient(config)
 // export const previewClient = createClient({
 //   ...config,
 //   useCdn: false,
 //   token: process.env.SANITY_PREVIEW_SECRET,
 //   // withCredentials: true
 // })
 // export const getClient = (usePreview) => (usePreview ? previewClient : client)
 // export default client
;


/***/ })

}]);